var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lo heading"},[_c('mdCaption',{attrs:{"caption":_vm.caption}},[(_vm.minorCaption)?_c('cpLabel',{attrs:{"themes":"minor","text":_vm.minorCaption}}):_vm._e()],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }